import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "row boxWrapper [ withBigBox ]"
};
const _hoisted_2 = { class: "[ col-lg-6 ] col-12 px-lg-3 px-sm-0 px-3" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = {
    key: 0,
    class: "productBoxWrapper [ col-lg-6 ] col-lg-3 col-md-6 col-sm-6 mt-sm-3 mt-2 mb-lg-3 mb-md-1 mb-2 px-lg-3 px-md-2 px-2"
};
const _hoisted_5 = { class: "col-lg-6 px-lg-3 px-sm-0 px-3 flex pb-lg-45 pb-sm-4 pb-3" };
const _hoisted_6 = { class: "row h-100" };
const _hoisted_7 = {
    key: 0,
    class: "productBoxWrapper [ hugeProductBox ] col-12 mt-sm-3 mt-2 h-100 px-lg-3 px-md-2 px-2"
};
const _hoisted_8 = {
    key: 1,
    class: "row boxWrapper [ withoutBigBox ]"
};
const _hoisted_9 = { class: "col-12 px-lg-3 px-sm-0 px-3" };
const _hoisted_10 = { class: "row" };
const _hoisted_11 = {
    key: 0,
    class: "col-12 pt-45 text-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_product_box = _resolveComponent("product-box");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        (_ctx.bigBox)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                (index < 4)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                        _createVNode(_component_product_box, { product: product }, null, 8, ["product"])
                                    ]))
                                    : _createCommentVNode("", true)
                            ], 64));
                        }), 128))
                    ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                (index === 4)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                        _createVNode(_component_product_box, { product: product }, null, 8, ["product"])
                                    ]))
                                    : _createCommentVNode("", true)
                            ], 64));
                        }), 128))
                    ])
                ])
            ]))
            : _createCommentVNode("", true),
        (!_ctx.bigBox)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "productBoxWrapper col-lg-3 col-md-6 col-sm-6 mt-sm-3 mt-2 mb-lg-3 mb-md-1 mb-2 px-lg-3 px-md-2 px-2"
                            }, [
                                _createVNode(_component_product_box, { product: product }, null, 8, ["product"])
                            ]));
                        }), 128))
                    ])
                ]),
                (_ctx.products.length < _ctx.total && !_ctx.bigBox)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("button", {
                            onClick: _cache[0] || (_cache[0] =
                                //@ts-ignore
                                (...args) => (_ctx.showMore && _ctx.showMore(...args))),
                            class: "buttonBase buttonGreen"
                        }, "Weitere Produkte anzeigen")
                    ]))
                    : _createCommentVNode("", true)
            ]))
            : _createCommentVNode("", true)
    ], 64));
}
